export const scrollTo = (id: string, block: ScrollLogicalPosition = 'start') => {
  const element = document.getElementById(id);
  element?.scrollIntoView({
    behavior: 'smooth',
    block,
  });
};
